import { FDRStatus } from '@cibo/core'
import { useAllFieldsGeoJSON } from '@cibo/landmanager'
import { MapTheme } from '@cibo/mapgl'
import { useMapPin } from '@cibo/mapgl/src/hooks'
import { Loading } from '@cibo/profile'
import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded'
import { Box, Button, Paper, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Layer, Source } from 'react-map-gl/dist/es5'
import { Link } from 'react-router-dom'
import { ADMIN_ROUTES } from '../../navigation/types'

interface EnrolledFieldsLayerProps {}

export const EnrolledFieldsLayer = (props: EnrolledFieldsLayerProps) => {
  const { t } = useTranslation('EnrolledFieldsLayer')
  const { palette } = useTheme<MapTheme>()

  //fetch all enrolled fields
  const enrolledFields = useAllFieldsGeoJSON({ fdrStatusAllOf: [{ status: FDRStatus.enrolled }] })
  const successPin = useMapPin('enrolled', palette.pinSuccessFill, palette.pinSuccessStroke)

  return (
    <>
      {!!enrolledFields.data?.items.points && (
        <Source type="geojson" data={enrolledFields.data.items.points} id="enrolled-field-points">
          <Layer
            type="symbol"
            layout={{
              'icon-image': successPin,
              'icon-size': 0.5,
              'icon-allow-overlap': true,
              'icon-anchor': 'bottom',
            }}
            filter={['!', ['has', 'point_count']]}
            paint={{ 'icon-opacity': ['interpolate', ['linear'], ['zoom'], 0, 1, 10, 1, 10.75, 0] }}
          />
        </Source>
      )}
      {!!enrolledFields.data?.items.shapes && (
        // @ts-ignore - type on shapes is possibly undefined
        <Source type="geojson" data={enrolledFields.data.items.shapes} id="enrolled-field-shapes">
          <Layer
            type="fill"
            paint={{
              'fill-opacity': ['interpolate', ['linear'], ['zoom'], 0, 0, 10, 0, 10.5, 0.3],
              'fill-color': palette.pinSuccessFill,
            }}
          />
          <Layer
            type="line"
            paint={{
              'line-opacity': ['interpolate', ['linear'], ['zoom'], 0, 0, 10, 0, 10.5, 1],
              'line-color': palette.pinSuccessFill,
              'line-width': 3,
            }}
          />
        </Source>
      )}

      <Box
        padding={1}
        paddingBottom={4}
        position="relative"
        height="100%"
        sx={{ pointerEvents: 'none' }}
      >
        <Stack flex={1}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Paper style={{ pointerEvents: 'all' }}>
              <Button
                component={Link}
                to={ADMIN_ROUTES.PROGRAM_LIST}
                variant="contained"
                startIcon={<ChevronLeftRounded />}
                size="small"
              >
                {t('back')}
              </Button>
            </Paper>
            <Typography variant="h6">
              {t('enrolledFields', { count: enrolledFields.data?.numAvailable })}
            </Typography>
          </Stack>
          {enrolledFields.isLoading && <Loading />}
        </Stack>
      </Box>
    </>
  )
}
